import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";

const BoroughTab = styled.div`
  align-items: center;
  border: 1px solid ${colorPalette.foxGrey};
  display: flex;
  height: 40px;
  justify-content: center;
  min-width: 16.67%;
  padding: 0 5px;
  width: 100%;
`;

const Button = styled.button`
  background: white;
`;

BoroughTab.displayName = "BoroughTab";
Button.displayName = "Button";

export { BoroughTab, Button };
